// extracted by mini-css-extract-plugin
export var container = "_s6-0";
export var inputWidth = "_s6-1";